import './index.scss'

import React, { useState } from 'react'
import T from 'prop-types'
import BEMHelper from 'react-bem-helper'
import { Link } from 'react-router-dom'
import Icon from 'components/Icon'

const bem = new BEMHelper('details')

export default function Details({
  title,
  description,
  data,
  type,
  truncate,
  className,
}) {
  const [expanded, setExpanded] = useState(false)
  const items = truncate && !expanded ? [...data.slice(0, truncate)] : data

  const toggle = () => {
    setExpanded((expanded) => !expanded)
  }

  return (
    <div {...bem('', type, className)}>
      {title && <h2 {...bem('title')}>{title}</h2>}
      {description && <p {...bem('description')}>{description}</p>}

      {items &&
        items.map(({ id, label, icon, value, comment, link, type, centered }) => {
          if (link) {
            return (
              <Link to={link.to} {...bem('item', 'link')} key={id}>
                {link.label}
                <Icon icon="smallArrow" {...bem('arrow')} />
              </Link>
            )
          }

          return (
            <dl {...bem('item', { left: !label, comment, centered })} key={id}>
              {(label || icon) && (
                <dt {...bem('label')}>
                  {icon && (
                    <span {...bem('icon')}>
                      <Icon icon={icon} />
                    </span>
                  )}
                  {label}
                </dt>
              )}
              <dd {...bem('value', type)}>{value || (comment ? '' : '—')}</dd>
              {comment && <dd {...bem('comment')}>{comment}</dd>}
            </dl>
          )
        })}

      {truncate && data.length > truncate && (
        <button
          type="button"
          onClick={toggle}
          aria-label={!expanded ? 'Vis mer' : 'Vis mindre'}
          {...bem('toggle')}
        >
          <Icon
            icon="chevron"
            direction={expanded ? 'up' : 'down'}
            {...bem('indicator')}
          />
        </button>
      )}
    </div>
  )
}

Details.propTypes = {
  title: T.string,
  description: T.string,
  data: T.array,
  type: T.oneOfType([T.string, T.array]),
  truncate: T.number,
  className: T.string,
}
